import { render, staticRenderFns } from "./PrevisualizarPdf.vue?vue&type=template&id=0748c627&scoped=true&"
import script from "./PrevisualizarPdf.vue?vue&type=script&lang=js&"
export * from "./PrevisualizarPdf.vue?vue&type=script&lang=js&"
import style0 from "./PrevisualizarPdf.vue?vue&type=style&index=0&id=0748c627&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0748c627",
  null
  
)

export default component.exports